import axios from 'axios'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions'

const OFFLINE_AWARE_CONFIG = {
  headers: {
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function cadastrarEncomendaAvulsa (comando) {
  const url = `${URL}/encomendas-avulsas/cadastrar`
  return () => axios.post(url, comando, OFFLINE_AWARE_CONFIG).then(response => response.data)
}
